<template>
  <Head title="Planning - Versions" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0">
          <versions :plans="plans" :client="client" :client_list="client_list"></versions>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  plans: Array,
  client: Object,
  client_list: Array
});
</script>

